import { Component, Inject, OnInit } from '@angular/core';
import { FuelService } from '../services/fuel.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditFuelComponent } from '../edit-fuel/edit-fuel.component';


@Component({
  selector: 'app-delete-fuel',
  templateUrl: './delete-fuel.component.html',
  styleUrls: ['./delete-fuel.component.scss']
})
export class DeleteFuelComponent implements OnInit {
  fuelID: number;
  businessID: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditFuelComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _fuelService: FuelService) {
    this.fuelID = data.fuelID;
    this.businessID = data.businessID;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._fuelService.deleteBusinessFuel(this.businessID, this.fuelID);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
